var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRouteNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 121,
    viewBox: "0 0 173 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.068 24.3367C123.068 36.885 113.089 47.2615 100.676 47.9854C100.189 47.9854 99.7019 47.9854 99.2151 47.9854C95.0774 47.9854 90.9397 46.7788 87.5321 44.8483C80.2302 40.746 75.3623 33.024 75.3623 24.0954C75.3623 18.0626 77.5529 12.5124 81.4472 8.4101C85.8283 3.58384 92.1566 0.446777 99.2151 0.446777C108.464 0.446777 116.496 5.75566 120.391 13.4777C122.094 16.856 123.068 20.4757 123.068 24.3367Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M122.859 24.3368C122.859 36.885 112.88 47.2615 100.467 47.9854C95.842 47.2615 91.4609 46.0549 87.3231 45.0897C80.0212 40.9874 75.1533 33.2653 75.1533 24.3368C75.1533 18.304 77.3439 12.7538 81.2382 8.65145C89.2703 8.41013 98.5194 9.13407 108.012 10.8233C112.393 11.5472 116.531 12.5125 120.425 13.4777C121.885 16.8561 122.859 20.4758 122.859 24.3368Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M151.961 40.3073C153.798 30.0731 131.149 17.5178 101.372 12.2641C71.5957 7.01049 45.9678 11.048 44.1308 21.2822C42.2939 31.5164 64.9434 44.0718 94.72 49.3254C124.497 54.5791 150.124 50.5415 151.961 40.3073Z",
    fill: "#E1E9FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7819 18.1078C93.9173 16.3804 91.2024 14.7624 87.7178 14.4937C84.2333 14.2251 81.2987 15.4077 81.1632 17.135C81.0278 18.8624 83.7427 20.4804 87.2273 20.7491C90.7118 21.0177 93.6464 19.8351 93.7819 18.1078Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1554 22.5443C66.5058 21.5581 68.8186 19.4123 68.3212 17.7515C67.8239 16.0907 64.7047 15.5438 61.3544 16.5299C58.0041 17.5161 55.6913 19.6619 56.1886 21.3227C56.6859 22.9836 59.8051 23.5305 63.1554 22.5443Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M118.397 24.4567C118.703 22.751 116.162 20.8761 112.721 20.269C109.28 19.6619 106.242 20.5525 105.936 22.2582C105.63 23.9639 108.171 25.8388 111.612 26.4459C115.053 27.053 118.09 26.1624 118.397 24.4567Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M136.874 37.0743C137.675 35.5344 135.806 32.9987 132.7 31.4107C129.593 29.8226 126.426 29.7836 125.625 31.3235C124.824 32.8634 126.693 35.3991 129.799 36.9871C132.906 38.5752 136.073 38.6142 136.874 37.0743Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0111 32.9789L72.1318 32.7375L39.5488 93.3418L131.002 102.96L120.811 41.1835L95.0111 32.9789Z",
    fill: "url(#paint0_linear_0_4945)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M142.956 119.084H25.8828C29.047 116.248 33.6715 113.413 39.0262 111.286C41.947 110.222 45.3545 108.804 48.7621 108.096C58.9847 105.26 71.3979 103.487 84.5413 103.487C100.362 103.487 114.966 105.969 126.162 109.868C130.056 111.286 133.464 112.704 136.385 114.476C139.062 115.894 141.253 117.312 142.956 119.084Z",
    fill: "url(#paint1_linear_0_4945)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M50.3826 109.81C50.536 111.25 48.0271 112.973 45.1227 113.283C42.2184 113.592 39.6703 112.65 39.275 111.236C42.1026 110.207 45.3887 108.886 48.726 108.045C49.7452 108.422 50.306 109.09 50.3826 109.81Z",
    fill: "url(#paint2_linear_0_4945)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M70.911 108.796C74.8093 108.796 77.9695 108.04 77.9695 107.107C77.9695 106.174 74.8093 105.418 70.911 105.418C67.0127 105.418 63.8525 106.174 63.8525 107.107C63.8525 108.04 67.0127 108.796 70.911 108.796Z",
    fill: "url(#paint3_linear_0_4945)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M108.957 108.658C109.037 107.461 105.949 106.283 102.059 106.028C98.1695 105.772 94.9514 106.535 94.8714 107.732C94.7914 108.929 97.8798 110.106 101.77 110.362C105.659 110.617 108.877 109.854 108.957 108.658Z",
    fill: "url(#paint4_linear_0_4945)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M135.755 114.095C134.788 113.984 133.627 114.021 132.203 113.614C128.362 112.928 125.357 111.367 125.495 110.168C125.523 109.929 125.523 109.929 125.793 109.717C129.551 111.122 132.967 112.481 135.755 114.095Z",
    fill: "url(#paint5_linear_0_4945)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M120.665 41.8069C121.489 37.2146 111.214 31.5611 97.7157 29.1795C84.217 26.7978 72.6059 28.5899 71.7816 33.1822C70.9573 37.7744 81.2319 43.4279 94.7307 45.8095C108.229 48.1912 119.84 46.3991 120.665 41.8069Z",
    fill: "currentColor"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2625 64.0466C33.2625 64.0466 24.8549 66.1813 27.4027 67.889C29.9504 69.5114 35.9802 72.3292 41.6702 70.4506C47.3602 68.5721 41.6702 65.9251 41.7551 65.9251C41.84 65.9251 33.2625 64.0466 33.2625 64.0466Z",
    fill: "#CED7E2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9863 63.3635C26.0437 64.3028 35.4704 62.7658 41.5001 58.838C46.256 64.7297 48.0394 66.2667 49.7379 66.4374C47.1052 69.0844 38.3579 73.3538 33.4322 67.8036C27.6572 71.4753 22.9863 63.3635 22.9863 63.3635Z",
    fill: "#E9EEF8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M123.971 71.0495C127.198 71.2203 135.945 67.2925 140.701 61.9985C146.816 66.524 148.854 67.5487 150.637 67.2925C148.684 70.5372 142.739 77.6243 134.332 78.1366C128.217 74.5504 123.971 71.0495 123.971 71.0495Z",
    fill: "#E9EEF8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M96.003 71.1551C95.3645 67.9871 89.3816 60.4939 83.0698 57.2067C85.9296 50.1575 86.4142 47.9283 85.7219 46.2649C89.3508 47.3483 97.6954 51.3404 100.286 59.3554C98.3358 66.1706 96.003 71.1551 96.003 71.1551Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M171.873 119.084H164.482H11.2686H1.7207",
    stroke: "#D6DFF2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M67.7473 99.6957V104.522H64.8265V109.107H59.2284V104.522H47.0586V98.9717L58.2548 83.5277H64.8265V99.6957H67.7473ZM59.4718 89.8018L52.4133 99.6957H59.4718V89.8018Z",
    fill: "currentColor"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M85.2722 109.59C79.4307 109.59 74.3193 104.522 74.3193 96.3174C74.3193 88.1127 79.4307 83.0452 85.2722 83.0452C91.1137 83.0452 96.225 88.1127 96.225 96.3174C96.4684 104.281 91.3571 109.59 85.2722 109.59ZM85.2722 104.522C87.9495 104.522 90.8703 101.868 90.8703 96.0761C90.8703 90.5259 88.1929 87.6301 85.2722 87.6301C82.5948 87.6301 79.6741 90.2846 79.6741 96.0761C79.9175 101.868 82.5948 104.522 85.2722 104.522Z",
    fill: "currentColor"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M123.972 99.6957V104.522H121.051V109.107H115.453V104.522H103.283V98.9717L114.479 83.5277H120.808V99.6957H123.972ZM115.453 89.8018L108.395 99.6957H115.453V89.8018Z",
    fill: "currentColor"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5559 99.6957V104.522H62.6351V109.107H57.037V104.522H44.8672V98.9717L56.0634 83.5277H62.3917V99.6957H65.5559ZM57.2804 89.8018L50.2219 99.6957H57.2804V89.8018Z",
    fill: "currentColor"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0808 109.59C77.2393 109.59 72.1279 104.522 72.1279 96.3174C72.1279 88.1127 77.2393 83.0452 83.0808 83.0452C88.9223 83.0452 94.0336 88.1127 94.0336 96.3174C94.277 104.281 89.1657 109.59 83.0808 109.59ZM83.0808 104.522C85.7581 104.522 88.6789 101.868 88.6789 96.0761C88.6789 90.5259 86.0015 87.6301 83.0808 87.6301C80.4034 87.6301 77.4826 90.2846 77.4826 96.0761C77.726 101.868 80.4034 104.522 83.0808 104.522Z",
    fill: "currentColor"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M121.78 99.6957V104.522H118.86V109.107H113.262V104.522H101.092V98.9717L112.288 83.5277H118.616V99.6957H121.78ZM113.262 89.8018L106.203 99.6957H113.262V89.8018Z",
    fill: "currentColor"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_4945",
    x1: 85.2812,
    y1: 35.177,
    x2: 85.2812,
    y2: 74.5919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D7CB8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_4945",
    x1: 84.4196,
    y1: 103.487,
    x2: 84.4196,
    y2: 119.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6BFD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#838DA7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_4945",
    x1: 44.6302,
    y1: 108.65,
    x2: 44.9171,
    y2: 111.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_4945",
    x1: 70.9121,
    y1: 105.535,
    x2: 70.9121,
    y2: 107.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_4945",
    x1: 95.3608,
    y1: 107.764,
    x2: 103.266,
    y2: 108.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_0_4945",
    x1: 130.858,
    y1: 110.414,
    x2: 130.65,
    y2: 112.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouteNotFound);
export default __webpack_public_path__ + "static/media/routeNotFound.21f5219ba36b0e2604ecc02d947b0231.svg";
export { ForwardRef as ReactComponent };